export default "__VITE_ASSET__7de132ff__"